import React from 'react';

import DeepResearchSection from '@components/pages/DeepResearchSection';

import type { DeepResearchBlockProps } from './interfaces';

const DeepResearchBlock = ({ content }: DeepResearchBlockProps) => {
  return (
    <DeepResearchSection
      description={content?.deep_research_description}
      isProSubscriberNotBot={true}
    />
  );
};

export default DeepResearchBlock;
